<template>
    <div class="wrapper card-header-background">
      <div class="flex justify_center pt2">
        <slot name="icon"></slot>
      </div>
      <h2 class="medium heading" style="margin: 0;">{{ title }}</h2>
      <slot name="subtitle"></slot>
      <p
        class="subheading"
        v-if="!!description"
      >
        {{ description }}
      </p>
      <div
        class="info-icon"
        @click="showModal=!showModal"
        v-if="infoConfig"
      >i</div>
      <div
        class="check-mark"
        v-if="hasCheckMark"
        :class="checked ? 'checked_background' : 'unchecked_background'"
      >
        <svg x="0px" y="0px" viewBox="0 0 512 512">
          <g>
            <path d="M504.502,75.496c-9.997-9.998-26.205-9.998-36.204,0L161.594,382.203L43.702,
            264.311c-9.997-9.998-26.205-9.997-36.204,0c-9.998,9.997-9.998,26.205,0,36.203l135.994,
            135.992c9.994,9.997,26.214,9.99,36.204,0L504.502,111.7C514.5,101.703,514.499,85.494,
            504.502,75.496z"/>
          </g>
        </svg>
      </div>

      <modal v-model="showModal" v-if="infoConfig">
        <div class="card-header-background relative pb3">
          <div class="flex justify_center pt2">
            <icon :icon-name="infoConfig.icon" xlarge/>
          </div>
          <div
            class="check-mark info_background info-modal"
          >
            <icon idea class="idea-icon"/>
          </div>
          <h2 class="medium heading"
              style="margin: 0;"
          >{{ infoConfig.cardHeader }}</h2>

          <p
            class="center_text mxa"
            style="max-width: 75%; margin-top: 10px;"
          >
            {{ infoConfig.cardSubtitle }}
          </p>
        </div>

        <div class="info-content-wrapper slightly_yellow_background">
          <div v-for="n in 5" :key="n"> <!-- Note: n from 1 to 5 -->
            <p v-if="infoConfig.contentHeaders[n-1]" class="title">
              {{ infoConfig.contentHeaders[n-1] }}
            </p>

            <p v-if="infoConfig.contentTexts[n-1]" class="subheading mb3">
              {{ infoConfig.contentTexts[n-1] }}
            </p>
          </div>
        </div>
        <div class="info-footer">
          <icon hihelloLogo />
          <p class="ml1">
            {{ $t('cms.info.footer.Content') }}
            <span style="text-decoration: underline;">{{ $t('cms.info.footer.Email') }}</span>
          </p>
        </div>
      </modal>

      <slot />
    </div>
</template>

<script>
export default {
  props: {
    title: { type: String },
    description: { type: String, required: false, default: null },
    hasCheckMark: { type: Boolean, required: false, default: false },
    checked: { type: Boolean, required: false, default: false },
    infoConfig: { type: Object, required: false, default: null },
  },

  data() {
    return {
      showModal: false,
    };
  },
};
</script>

<style lang="scss" scoped>
  .wrapper {
    position: relative;
    margin: -$card_padding;
    margin-bottom: $card_padding;
    padding-bottom: $base_spacing;
  }

  .info-icon {
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    border: 2px solid white;
    color: white;
    background-color: black;
    font-weight: 700;
    cursor: pointer;
  }

  .check-mark {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    clip-path: polygon(50px 0, 0 0, 0 40px);
    color: white;
    font-size: 22px;
    padding: 3px 0 0 6px;
    svg {
      width: 20px;
      height: 20px;
      fill: white;
    }
    &.info-modal{
      clip-path: polygon(50px 0, 0 0, 0 45px);
    }
  }

  .idea-icon {
    height: 20px!important;
    width: 20px!important;
  }

  .info-content-wrapper {
    padding: 20px;
    max-height: 70vh;
    overflow-y: scroll;

    .title {
      font-weight: 700;
      text-decoration: underline;
    }

    .subheading {
      line-height: 20px;
      text-align: left;
    }
  }

  .info-footer {
    display: flex;
    align-items: center;
    padding: 15px 10px;
    border-top: 1px dashed gray;
    background-color: $color_background_card_footer;
  }
</style>
